<template>
  <div class="lineChart">
    <!-- 图表统计 -->
    <a-row :gutter="[24,24]" type="flex">
      <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
        <div class="bg-white p-y-15 p-x-24 border-radius-12" style="height: 100%">
          <tk-flex middle between>
            <div class="font-14 flex-s-0" >销售额</div>
            <tk-flex wrap :gutter="10">
              <!-- :defaultValue="getDefaultDate()" -->
              <a-range-picker
                :defaultValue="_defaultDate"
                @change="(date, dateString) => onChange(date, dateString, 'sell')"
                style="maxWidth: 250px"
              />
            </tk-flex>
          </tk-flex>
          <div class="font-14 m-t-12">销售额：<span class="font-16 font-bold">{{ orderSumSales }}</span></div>
          <div ref="sellOrder" style="width: 100%;height: 300px"></div>
        </div>
      </a-col>
      <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
        <div class="bg-white p-y-15 p-x-24 border-radius-12">
          <tk-flex middle between>
            <div class="font-14 flex-s-0" >订单量</div>
            <tk-flex wrap :gutter="10">
              <!-- :defaultValue="getDefaultDate()" -->
              <a-range-picker
                :defaultValue="_defaultDate"
                @change="(date, dateString) => onChange(date, dateString, 'num')"
                style="maxWidth: 250px;"
              />
            </tk-flex>
          </tk-flex>
          <div class="font-14 m-t-12">订单量：<span class="font-16 font-bold">{{ orderSumTotal }}</span></div>
          <div ref="orderNum" style="width: 100%;height: 300px"></div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { getDayAll, formatDate } from '@/assets/js/utils.js'

export default {
  components: {
    // selectType
  },
  data () {
    return {
      option: {
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            // eslint-disable-next-line no-template-curly-in-string
            formatter: '￥{value}'
          }
        },
        grid: { // 让图表占满容器
          top: '40px',
          left: '54px',
          right: '24px',
          bottom: '40px'
        },
        tooltip: {
          trigger: 'axis',
          show: true,
          formatter: params => {
            // 获取xAxis data中的数据
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 15px;">${params[0].name}</p></div>`
            params.forEach(item => {
              dataStr += `<div>
                <div style="margin: 0 8px;">
                  <span>销售额</span>
                  <span style="float:right;color:#000000;margin-left:20px;">${item.data}</span>
                </div>
              </div>`
            })
            return dataStr
          }
        },
        series: [
          {
            data: [],
            type: 'line',
            symbol: 'circle', // 设定为实心点
            symbolSize: 8, // 设定实心点的大小
            color: '#2FC25B', // 设定实线点的颜色
            lineStyle: {
              normal: {
                width: 3,
                color: '#2FC25B' // 设置实线的颜色
              }
            }
          }
        ]
      },
      optionNum: {
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
          // axisLabel: {
          //   // eslint-disable-next-line no-template-curly-in-string
          //   formatter: '${value}'
          // }
        },
        grid: { // 让图表占满容器
          top: '40px',
          left: '54px',
          right: '24px',
          bottom: '40px'
        },
        tooltip: {
          trigger: 'axis',
          show: true,
          formatter: params => {
            // 获取xAxis data中的数据
            let dataStr = `<div><p style="font-weight:bold;margin:0 8px 15px;">${params[0].name}</p></div>`
            params.forEach(item => {
              dataStr += `<div>
                <div style="margin: 0 8px;">
                  <span>订单量</span>
                  <span style="float:right;color:#000000;margin-left:20px;">${item.data}</span>
                </div>
              </div>`
            })
            return dataStr
          }
        },
        series: [
          {
            data: [],
            type: 'line',
            symbol: 'circle', // 设定为实心点
            symbolSize: 8, // 设定实心点的大小
            color: '#158DFC', // 设定实线点的颜色
            lineStyle: {
              normal: {
                width: 3,
                color: '#158DFC' // 设置实线的颜色
              }
            }
          }
        ]
      },
      firstDay: this.getDefaultDate()[0],
      lastDay: this.getDefaultDate()[1],
      /// 订单量下拉选择类型
      orderType: 'sellOrder',
      /// 订单量二级下拉选择类型
      secondOrderType: '&&&',
      /// 销售额下拉选择类型
      orderTypeSales: 'sellOrder',
      /// 销售额二级下拉选择类型
      secondOrderTypeSales: '&&&',
      orderSumTotal: 0,
      orderSumSales: 0
    }
  },
  computed: {
    ...mapState(['user']),
    _defaultDate () {
      return [moment(this.getDefaultDate()[0]), moment(this.getDefaultDate()[1])]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    moment,
    getDefaultDate (firs, last) {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0)
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)
      if (firs) firstDay = new Date(new Date(firs).setHours(0, 0, 0, 0))
      if (last) lastDay = new Date(new Date(last).setHours(23, 59, 59, 999))
      return [firstDay, lastDay]
    },
    init () {
      this.initOrders('sell')
      this.initOrders('num')
      this.getGroupOrders(this.getDefaultDate()[0],
        this.getDefaultDate()[1], 'sell')
      this.getGroupOrders(this.getDefaultDate()[0],
        this.getDefaultDate()[1], 'num')
    },
    initWhere () {
      let where = {}
      /// 对应部门下面的销售额
      if (this.user.adminRole === 'staff') {
        if (this.user.level === '1') where.warZone = this.user.department
        if (this.user.level === '2') where.regional = this.user.department
        if (this.user.level === '3') {
          where.agency = this.user.department
          where.agent = this.user.objectId
        }
        if (this.user.level === '4') {
          where.salesmancy = this.user.department
          where.salesman = this.user.objectId
        }
      }
      return where
    },
    // 默认展示当月的数据
    initOrders (type) {
      let iso = this.getDefaultDate()
      this.setOption(formatDate(iso[0]), formatDate(iso[1]), iso[0].toISOString(), iso[1].toISOString(), type)
    },
    onChange (date, dateString, type) {
      if (dateString[0] === '') {
        type === 'sell' ? this.initOrders(type) : this.initOrders(type)
        return
      }
      let iso = this.getDefaultDate(dateString[0], dateString[1])
      this.setOption(formatDate(iso[0]), formatDate(iso[1]), iso[0].toISOString(), iso[1].toISOString(), type)
    },
    // 请求数据，并设置数据， 刷新图表
    async setOption (firstTime, lastTime, firstDay, lastDay, type) {
      // 获取对应数据
      let data = await this.getGroupOrders(firstDay, lastDay, type)
      // 操作成图表需要的格式
      let newData = await this.dateline(firstTime, lastTime, data)
      // 日期赋值
      type === 'sell' ? this.option.xAxis.data = newData[0] : this.optionNum.xAxis.data = newData[0]
      // 日期对应数据赋值
      type === 'sell' ? this.option.series[0].data = newData[1] : this.optionNum.series[0].data = newData[1]
      // 渲染图表
      this.sellOrderLine(type)
    },
    /// 统计销售额/订单量
    async getGroupOrders (firstDay, lastDay, type) {
      let where = this.initWhere()
      let match = {
        ...{ status: '2' },
        ...{
          finishTime: {
            $gt: firstDay,
            $lt: lastDay
          }
        },
        ...where
      }
      let { data: res } = await this.$tkParse.get(`/aggregate/order`, {
        params: {
          group: {
            objectId: {
              day: { $dayOfMonth: '$finishTime' },
              month: { $month: '$finishTime' },
              year: { $year: '$finishTime' },
              type: '$finishTime'
            },
            total: type === 'sell' ? {
              $sum: '$orderAmount'
            } : {
              $sum: 1
            }
          },
          match: match
        }
      })
      let { data: total } = await this.$tkParse.get(`/aggregate/order`, {
        params: {
          group: {
            objectId: '',
            total: type === 'sell' ? {
              $sum: '$orderAmount'
            } : {
              $sum: 1
            }
          },
          match: match
        }
      })
      if (type === 'sell') this.orderSumSales = total.results && total.results.length ? total.results[0].total || 0 : 0
      else this.orderSumTotal = total.results && total.results.length ? total.results[0].total || 0 : 0
      return res.results
    },
    // 销售额/订单量统计
    sellOrderLine (type) {
      let mychart = this.$echarts.init(type === 'sell' ? this.$refs.sellOrder : this.$refs.orderNum)
      mychart.setOption(type === 'sell' ? this.option : this.optionNum)
      // 自动渲染echarts
      window.addEventListener('resize', () => {
        mychart.resize()
      })
    },
    async dateline (firstTime, lastTime, data) {
      var dataAll = getDayAll(firstTime, lastTime)

      var dataNull = dataAll[1]

      // 获取的数据，拼接时间，对比空数据索引，赋值
      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        let time = element.objectId.year + '-' + (element.objectId.month >= 10 ? element.objectId.month : ('0' + element.objectId.month)) + '-' + (element.objectId.day >= 10 ? element.objectId.day : ('0' + element.objectId.day))
        let i = dataAll[0].indexOf(time)
        if (i !== -1) dataNull[i] = element.total
      }

      let newData = []
      for (let index = 0; index < dataAll[0].length; index++) {
        const element = dataAll[0][index]
        let str = element.split('-')
        newData.push(str[1] + '/' + str[2])
      }
      return [newData, dataNull]
    }
  }
}
</script>
<style scoped lang="scss">
.lineChart{
  box-sizing: border-box;
}
</style>
